import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api/trpc';

// Live "similar tickets" search while the reporter types a title (create
// form) — surfaces existing tickets to vote on instead of filing a
// duplicate. Gated to 3+ chars to skip noisy single/two-letter matches;
// `keepPreviousData` holds the last result on screen between keystrokes
// instead of flashing empty while the next query resolves.
export const useSearchSimilarTickets = (query: string) => {
  const q = query.trim();
  return trpc.support.searchSimilar.useQuery(
    { query: q, limit: 5 },
    { enabled: q.length >= 3, placeholderData: keepPreviousData }
  );
};
